import { createActionHandler, createReducer, OperationStatus } from '@pressreader/appstore';
import { IssueLayout } from '@pressreader/content-types';

import { loadIssueLayoutBeganEvent, loadIssueLayoutDoneEvent, loadIssueLayoutFailedEvent } from '../actions/layout';

type State = Record<string, { layout: IssueLayout | null; loading: OperationStatus }>;

const initialState: State = {};

const reducer = createReducer<State>(
    initialState,
    createActionHandler(loadIssueLayoutBeganEvent, (state, action): State => {
        const { cidDateKey } = action.payload;

        if (state[cidDateKey]) {
            return {
                ...state,
                [cidDateKey]: {
                    ...state[cidDateKey],
                    loading: OperationStatus.Pending,
                },
            };
        }

        return {
            ...state,
            [cidDateKey]: {
                layout: null,
                loading: OperationStatus.Pending,
            },
        };
    }),
    createActionHandler(loadIssueLayoutDoneEvent, (state, action): State => {
        const { cidDateKey, layout } = action.payload;

        return {
            ...state,
            [cidDateKey]: {
                ...state[cidDateKey],
                layout,
                loading: OperationStatus.Done,
            },
        };
    }),
    createActionHandler(loadIssueLayoutFailedEvent, (state, action): State => {
        const { cidDateKey } = action.payload;

        return {
            ...state,
            [cidDateKey]: {
                ...state[cidDateKey],
                loading: OperationStatus.Failed,
            },
        };
    }),
);

export { State, reducer };
